/**
 * Delegated click copy for `.clipboard[data-clipboard-text]` (share modal, etc.).
 * Registered from application pack on DOM ready / turbolinks:load so it does not
 * wait on controller init (which may be delayed by async `getScript` chains).
 */
function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text)
  }

  return new Promise((resolve, reject) => {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "fixed"
    textarea.style.top = "0"
    textarea.style.left = "0"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()
    textarea.setSelectionRange(0, text.length)
    try {
      const ok = document.execCommand("copy")
      document.body.removeChild(textarea)
      if (ok) resolve()
      else reject(new Error("execCommand copy returned false"))
    } catch (err) {
      if (textarea.parentNode) document.body.removeChild(textarea)
      reject(err)
    }
  })
}

function onDocumentClick(event) {
  const trigger = event.target.closest(".clipboard[data-clipboard-text]")
  if (!trigger) return

  const text = trigger.getAttribute("data-clipboard-text")
  if (!text) return

  copyToClipboard(text)
    .then(() => {
      trigger.classList.add("clipboard--copied")
      window.setTimeout(() => trigger.classList.remove("clipboard--copied"), 2000)
    })
    .catch(() => {
      if (typeof window.swal === "function") {
        window.swal({
          title: "Could not copy",
          text: "Select the link in the address bar or try another browser.",
          type: "error",
        })
      }
    })
}

export default function initClipboardDelegation() {
  if (window.__unitedCertifiersClipboardDelegation) return
  window.__unitedCertifiersClipboardDelegation = true
  document.addEventListener("click", onDocumentClick)
}
